/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

export type ECGWaveformEnum =
  (typeof ECGWaveformEnum)[keyof typeof ECGWaveformEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ECGWaveformEnum = {
  NONE: 'NONE',
  NORMAL: 'NORMAL',
  SINUS_RHYTHM: 'SINUS_RHYTHM',
  SINUS_BRADYCARDIA: 'SINUS_BRADYCARDIA',
  SINUS_TACHYCARDIA: 'SINUS_TACHYCARDIA',
  ASYSTOLE: 'ASYSTOLE',
  ARRHYTHMIA: 'ARRHYTHMIA',
  PEA: 'PEA',
  VENTRICULAR_FIBRILLATION: 'VENTRICULAR_FIBRILLATION',
  VENTRICULAR_TACHYCARDIA: 'VENTRICULAR_TACHYCARDIA',
  PULSELESS_VT: 'PULSELESS_VT',
  ATRIAL_FIBRILLATION: 'ATRIAL_FIBRILLATION',
  ATRIAL_FLUTTER: 'ATRIAL_FLUTTER',
  PSVT: 'PSVT',
  AV_BLOCK: 'AV_BLOCK',
  FIRST_DEGREE_AV_BLOCK: 'FIRST_DEGREE_AV_BLOCK',
  SECOND_DEGREE_AV_BLOCK: 'SECOND_DEGREE_AV_BLOCK',
  THIRD_DEGREE_AV_BLOCK: 'THIRD_DEGREE_AV_BLOCK',
  BUNDLE_BRANCH_BLOCK: 'BUNDLE_BRANCH_BLOCK',
  BRADYCARDIA: 'BRADYCARDIA',
  TACHYCARDIA: 'TACHYCARDIA',
  ST_ELEVATION: 'ST_ELEVATION',
  ST_DEPRESSION: 'ST_DEPRESSION',
  PVC: 'PVC',
  VPC: 'VPC',
  OTHER: 'OTHER',
} as const;
